import { TranslatedCopy } from '../../intl/TranslatedCopy';

const sizeChartColumns = [
  {
    header: <TranslatedCopy id='gridwall.filters.size' />,
    id: 'size',
    cell: size => {
      return <span className='text-color-primary'>{size.sizeDisplay || size.code}</span> || null;
    }
  },
  {
    header: <TranslatedCopy id='orderreturns.sizetable.orderedQuantity' />,
    id: 'orderedQuantity',
    cell: size => {
      return <span className='text-color-secondary'>{size.totalRequestedQty}</span> || null;
    }
  },
  {
    header: <TranslatedCopy id='orderreturns.sizetable.returnedQuantity' />,
    id: 'returnedQuantity',
    cell: size => {
      return <span className='text-color-secondary'>{size.quantity === 0 ? '' : size.quantity}</span>;
    }
  }
];

export default sizeChartColumns;
